module.exports = __webpack_public_path__ + "img/dellotie.a3f541bb.svg";